import React, { JSX } from "react";
import { Link } from "react-router";
import styled from "styled-components";
import encartBacImage from "@assets/images/ENCART_BAC_24.jpg";
import { Path } from "@core/routing/path";
import { BackgroundImage } from "@ui/components/backgroundImage";

interface sliderPubProps extends React.HTMLAttributes<HTMLDivElement> {
	items?: Array<string>;
}

const TOOSHARE_PAGE_PRO_SLUG = "tooshare-examens-et-concours";

export const SliderPub: React.FC<sliderPubProps> = (): JSX.Element => {
	return (
		<Content>
			<Link to={Path.Organization({ slug: TOOSHARE_PAGE_PRO_SLUG })}>
				<StyledBackgroundImage image={encartBacImage} defaultUrl={encartBacImage} />
			</Link>
		</Content>
	);
};

const Content = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	border-radius: 12px;
	cursor: pointer;
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.backgroundPrimary};
	height: 309x;
`;

const StyledBackgroundImage = styled(BackgroundImage)<{ height?: number }>`
	height: ${({ height = 309 }) => height}px;
`;

// const Infos = styled.div`
// 	${({ theme }) => theme.textStyles.text};
// 	color: ${({ theme }) => theme.colors.black};
// 	padding: 0px 15px;
// 	display: flex;
// 	flex-direction: column;
// 	align-items: flex-start;
// 	justify-content: flex-end;
// 	position: absolute;
// 	left: 0;
// 	right: 0;
// 	bottom: 5px;
// `;
